import { useState } from 'react';
import Overlay from '../ui/Overlay';
import styles from '../ui/Overlay.module.css';
import { Link } from 'react-router-dom';

const ExistingTransactionOverlay = ({ onClose, onDelete }) => {
    const [confirmDelete, setConfirmDelete] = useState(false);

    const handleClose = () => {
        onClose();
    }

    const handleDelete = () => {
        if (confirmDelete && onDelete) {
            onDelete();
        }
    }

    return (
        <Overlay
            headerTitle={"Wait!"}
            onClose={handleClose}
            className={styles.overlayContentDefault}
            persist={true}
        >
            <div className="">
                <p>
                    You have an existing debt snowball plan. In order to proceed, your existing snowball transactions will be deleted and replaced with new transactions. This action cannot be undone.
                </p>

                <p>
                    Are you sure you want to delete your existing snowball transactions?
                </p>

                <div
                    className="formField formField-inline-checkbox"
                    style={{ marginBottom: "0", marginTop: "1rem"}}
                >
                    <input
                        type="checkbox"
                        id="confirmDelete"
                        onChange={(e) => setConfirmDelete(e.target.checked)}
                    />
                    <label htmlFor="confirmDelete">Yes, I understand</label>
                </div>

                <button
                    className="button button-red spc-m-b-1"
                    onClick={handleDelete}
                    disabled={!confirmDelete}
                >
                    Delete & Proceed
                </button>

                <hr />

                <h4 className="spc-m-t-0">Review Your Existing Snowball Info</h4>

                <div className="button-row">
                    <Link
                        className="button button-blue"
                        to="/transactions?snowball=true"
                    >
                        Existing Transactions
                    </Link>

                    <Link
                        className="button button-stroke-blue"
                        to="/tools/snowball-schedule"
                    >
                        Existing Plan
                    </Link>
                </div>
            </div>
        </Overlay>
    )
}

export default ExistingTransactionOverlay